import { CheckCircle2 } from "lucide-react";
import { useTranslation } from "react-i18next"; // 1. Import hook i18n

export default function ActivationAlreadyPage() {
    const { t } = useTranslation('registration'); // 2. Gunakan namespace registration

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 to-green-100 px-4">
            <div className="bg-white shadow-md rounded-2xl p-10 text-center max-w-md w-full">
                <div className="flex justify-center mb-6">
                    <CheckCircle2 className="w-16 h-16 text-green-500" />
                </div>
                <h1 className="text-2xl font-bold text-green-700 mb-3">
                    {t('activation_already.title')}
                </h1>
                <p className="text-gray-700 mb-6 leading-relaxed">
                    {t('activation_already.description')}
                    <br />{t('activation_already.instruction')}
                </p>
                <a
                    href="/login"
                    className="inline-block px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition font-semibold w-full sm:w-auto"
                >
                    {t('activation_already.btn_login')}
                </a>
            </div>
        </div>
    );
}